import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import {
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  getBreedSpeciesSpecimensDetails,
  getCAVSMaster,
} from "../../api/apimethods";
import { TERMetaContext } from "../../App";
import Header from "../../components/molecules/Header/Header";
import { IBioMaster } from "../../typings/models/BioMaster";
import { Button, Modal } from "react-bootstrap";
import Stepwizard from "../LabDetails/Helper/Stepwizard";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import { ITERRequest } from "../../typings/interfaces/Requests/TERRequest";
import { notify } from "../../utils";
import { useNavigate, useLocation } from "react-router-dom";
import { ITERSamplesAndTests } from "../../typings/models/TERSamplesAndTests";
import PersonalInformation from "./Helper/ProfileInformation";
import { ITestCodeMasterModel } from "../../typings/models/TestCodeMasterModel";
import moment from "moment";
import { ITERSampleDetails } from "../../typings/models/TERSampleDetails";
import { ICAVSMaster } from "../../typings/models/CAVSMaster";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import { IlabTERPreference } from "../../typings/models/TERPreference";
import { ILabSpeciesMaster } from "../../typings/models/LabSpeciesMaster";
import { ILabBreedMaster } from "../../typings/models/LabBreedMaster";
import { ILabSpecimenMaster } from "../../typings/models/LabSpecimenMaster";
import Loader from "../../components/molecules/Loader";
import { NotifyType } from "../../utils/app-config";
function CAVSTERReview() {
  let bannerName = "Application for Laboratory Testing";
  const location = useLocation();
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate());
  const maxdate = currentDate.toISOString().split("T")[0];
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [showPostMortem, setShowPostMortem] = useState(false);
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [showAdditionalContent, setShowAdditionalContent] = useState(false);
  const [isClinicalManagementExpanded, setIsClinicalManagementExpanded] =
    useState(false);
  const [showGroupAnimals, setShowGroupAnimals] = useState(false);
  const { message } = notify();
  const { TERMeta } = useContext(TERMetaContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [countryOptions, setCountryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [showFarmDetails, setShowFarmDetails] = useState(false);
  const [showFarmLocationDetails, setShowFarmLocationDetails] = useState(false);
  const [showQuarantineInfo, setShowQuarantineInfo] = useState(false);
  const [TERSampleDetails, setTERSampleDetails] = useState<ITERSampleDetails>();
  const [premisesCodeOptions, setpremisesCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const handleToggleForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowForm((prevShowForm) => !prevShowForm);
  };
  const [speciesOptions, setSpeciesOptions] = useState<ILabSpeciesMaster[]>();
  const [breedOptions, setBreedOptions] = useState<ILabBreedMaster[]>();
  const [specimenOptions, setSpecimenOptions] =
    useState<ILabSpecimenMaster[]>();
  const [samplesAndTests, setSamplesAndTests] = useState<ITERSamplesAndTests[]>(
    [
      {
        id: Date.now(),
        sampleMarking: "",
        species: "",
        breed: "",
        specimenDescription: "",
        labTERTestDetails: [],
        noOnPremises: 0,
        noInGroup: 0,
        noSick: 0,
        noDead: 0,
        noAtRisk: 0,
        groupID: "",
        sterilized: 0,
        longitude: "",
        latitude: "",
        penNo: "",
        owner: "",
        microchipNo: "",
        gender: "",
        nameofAnimal: "",
        years: 0,
        months: 0,
        weeks: 0,
        dateofBirth: null,
        countryofResidence: "",
        SupportDocumentName: "",
        SupportDocuments: "",
        saveRemains: null,
        methodofEuthanised: "",
        euthanisedDate: null,
        euthanised: false,
        remarks: "",
        animalStatus: null,
        noOfSamples: 1,
      },
    ]
  );
  const [isVaccinationHistoryExpanded, setIsVaccinationHistoryExpanded] =
    useState(false);
  const toggleVaccinationHistory = () => {
    setIsVaccinationHistoryExpanded((prev) => !prev);
  };

  const toggleQuarantineInfo = () => {
    setShowQuarantineInfo((prev) => !prev);
  };
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [testDescription, setTestDescription] = useState<string>("");
  const [TestLaboratory, setTestLaboratory] = useState<string>("");
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<IBioPurposeOfTest[]>();
  const [speciesSelectOptions, setSpeciesSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [breedSelectOptions, setBreedSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [specimenSelectOptions, setSpecimenSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [Preference, setPreference] = useState<IlabTERPreference[]>([]);
  const [testOptions, setTestOptions] = useState<ITestCodeMasterModel[]>([]);
  const handleToggleFarmDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setShowFarmDetails((prevShowFarmDetails) => !prevShowFarmDetails);
  };

  const navigate = useNavigate();
  const handlePreviousClick = async () => {
    const meta: ITERRequest = TERMeta.TERMeta;
    const applicationNumber = meta?.applicationNumber;
    const actionStatus = meta?.actionStatus;
    localStorage.setItem("ismetadata", "1");
    if (applicationNumber && actionStatus) {
      const url = `/ter-samples-and-tests?an=${applicationNumber}&type=${actionStatus}`;
      navigate(url);
    } else {
      navigate("/ter-samples-and-tests");
    }
  };
  const toggleClinicalManagement = () => {
    setIsClinicalManagementExpanded((prev) => !prev);
  };
  const handleDiseaseSignClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowAdditionalContent(!showAdditionalContent);
  };
  const stepWizardConfig: IStepwizardProps = {
    currentStep: 3,
    steps: [
      {
        name: "Choose Application",
      },

      {
        name: "Samples & Tests",
      },
      {
        name: "Review",
      },
      {
        name: "Cost & Confirm",
      },
      {
        name: "Acknowledgement",
      },
    ],
  };
  const handleNextClick = () => {
    const modeOfPayment = localStorage.getItem("modeOfPayment");
    const meta: ITERRequest = TERMeta.TERMeta;
    const purposeOfTest = meta?.labTERApplicationDetails?.purposeOfTest;

    if (purposeOfTest === 1 && modeOfPayment !== "Biosurveillance") {
      setErrorMessage(
        "You cannot proceed with Biosurveillance as the purpose of the test with other than Biosurveillance as the payment mode. Please select Biosurveillance as the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    if (modeOfPayment === "Biosurveillance" && purposeOfTest !== 1) {
      setErrorMessage(
        "You cannot proceed with a Purpose of Application other than Biosurveillance since the payment mode is Biosurveillance. Please change the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    setErrorMessage("");
    navigate("/ter-cost-and-confirm");
  };
  const handleToggleFarmLocationDetails = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();

    setShowFarmLocationDetails(
      (prevshowFarmLocationDetails) => !showFarmLocationDetails
    );
  };
  useEffect(() => {
    getMaster();
  }, []);

  const getMaster = async () => {
    try {
      setPageLoader(true);

      const response = await getCAVSMaster();
      if (response?.status === 200) {
        const cavsMaster: ICAVSMaster = response.data;
        const bioMaster: IBioMaster = cavsMaster.bioMasters;

        if (bioMaster) {
          const purposeTest = bioMaster.testPurpose;
          const purposeTestArr = Object.entries(purposeTest).map(
            ([name, id]) => ({
              id,
              name,
            })
          );
          setPurposeOfTestOptions(purposeTestArr);
        }
        const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
        if (bioSurveillanceProgram) {
          const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
            (result: any) => ({
              label: result.name,
              value: result.CodeValue,
            })
          );
          setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
          const premisesMaster = bioMaster?.premisesMaster || [];
          const premisesCodeOptions = premisesMaster.map((result: any) => ({
            label: result.premisesCode,
            value: result.premisesCode,
          }));

          setpremisesCodeOptions(premisesCodeOptions);
        }
      }
      const countryRes = await getBioCountryOfDestination();
      setCountryOfDestinationOptions(countryRes?.data || []);

      const conutryRes = await getBioCountryOfOrigin();
      setCountryOfOriginOptions(conutryRes?.data || []);
      const countryOptions = (countryRes?.data || []).map((country) => ({
        value: country.name,
        label: country.name,
      }));
      setCountryOptions(countryOptions);

      const breedspeciesresponse = await getBreedSpeciesSpecimensDetails("TER");

      if (breedspeciesresponse.status == 200) {
        let species = breedspeciesresponse?.data?.labSpecies;

        if (species) {
          let values: any[] = Object.values(species);
          let speciesArr: any[] = Object.keys(species).map((x, ind) => {
            return {
              speciesName: values[ind].speciesName,
            };
          });
          setSpeciesOptions(speciesArr);
        }

        let breeds = breedspeciesresponse?.data?.labBreed;

        if (breeds) {
          let values: any[] = Object.values(breeds);
          let breedArr: any[] = Object.keys(breeds).map((x, ind) => {
            return {
              breedName: values[ind].breedName,
            };
          });
          setBreedOptions(breedArr);
        }

        let specimens = breedspeciesresponse?.data?.labSpecimen;

        if (specimens) {
          let values: any[] = Object.values(specimens);
          let specimensArr: any[] = Object.keys(specimens).map((x, ind) => {
            return {
              labSpecimenDescription: values[ind].labSpecimenDescription,
            };
          });
          setSpecimenOptions(specimensArr);
        }
      }
      const meta: ITERRequest = TERMeta.TERMeta;
      if (Object.keys(meta)?.length) {
        const {
          labTERApplicationDetails,
          labTERSampleTests,
          labTERPreference,
        } = meta;

        setTERSampleDetails(labTERApplicationDetails as ITERSampleDetails);
        setSamplesAndTests(labTERSampleTests);
        setPreference([labTERPreference]);
      }

      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };
  useEffect(() => {
    if (speciesOptions) {
      const speciesOpts = [
        ...speciesOptions.map((species) => ({
          label: species.speciesName,
          value: species.speciesName,
        })),
        { label: "Others", value: "Others" },
      ];
      setSpeciesSelectOptions(speciesOpts);
    }

    if (breedOptions) {
      const breedOpts = [
        ...breedOptions.map((breed) => ({
          label: breed.breedName,
          value: breed.breedName,
        })),
        { label: "Others", value: "Others" },
      ];
      setBreedSelectOptions(breedOpts);
    }

    if (specimenOptions) {
      const specimenOpts = [
        ...specimenOptions.map((specimen) => ({
          label: specimen.labSpecimenDescription,
          value: specimen.labSpecimenDescription,
        })),
        { label: "Others", value: "Others" },
      ];
      setSpecimenSelectOptions(specimenOpts);
    }
  }, [speciesOptions, breedOptions, specimenOptions]);
  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>

        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />

        <div className="row setup-content" id="step-1">
          <div className="col-md-12">
            <div className="tab-wizard-content">
              {errorMessage && (
                <div className="info-content">
                  <div className="att">
                    <br />
                    <div className="text-danger">
                      <center>{errorMessage}</center>
                    </div>
                  </div>
                </div>
              )}
              <PersonalInformation />

              <div className="personal-info">
                <div className="info-heading">
                  <h3 className="info-h3">Sample Details</h3>
                </div>
                {pageLoader ? (
                  <Loader />
                ) : (
                  <>
                    <div className="info-content">
                      <div className="row-mt-2">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="row">
                              <div className="col-lg-6">
                                <label className="form-check-label" htmlFor="">
                                  Purpose of Application
                                  <span className="star-red">*</span>
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <select
                                  className={`form-select ${
                                    TERSampleDetails?.purposeOfTestErrMsg
                                      ? "border-danger op05"
                                      : ""
                                  }`}
                                  aria-label="Default select example"
                                  name="purposeOfTest"
                                  disabled
                                  value={TERSampleDetails?.purposeOfTest}
                                >
                                  <option selected>-- Select --</option>
                                  {purposeOfTestOptions &&
                                    purposeOfTestOptions.map((x) => {
                                      return (
                                        <option value={x.id}>{x.name}</option>
                                      );
                                    })}
                                </select>

                                {TERSampleDetails?.purposeOfTest === 7 && (
                                  <div className="col-lg-12 mt-2">
                                    <input
                                      type="text"
                                      disabled
                                      className={`form-control ${
                                        !TERSampleDetails?.otherPurposeOfTest
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      placeholder="Enter Purpose of Application"
                                      name="otherPurposeOfTest"
                                      value={
                                        TERSampleDetails?.otherPurposeOfTest
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-lg-3">
                            <label
                              className="form-check-label"
                              htmlFor="referringVeterinarian"
                            >
                              Referring Veterinarian
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="text"
                              className="form-control"
                              disabled
                              name="referringVeterinarian"
                              value={TERSampleDetails?.referringVeterinarian}
                            />
                          </div> */}

                          <div className="col-lg-3">
                            <label htmlFor="crossReference">
                              Cross Reference
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="text"
                              id="crossReference"
                              name="crossReference"
                              value={TERSampleDetails?.crossReference}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>

                        {TERSampleDetails?.purposeOfTest === 1 && (
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="row">
                                <div className="col-lg-6">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Biosurveillance Program
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-6">
                                  <div className="col-lg-12 mt-2">
                                    <select
                                      className={`form-select ${
                                        TERSampleDetails?.bioSurveillanceProgramErrMsg
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      aria-label="Default select example"
                                      name="bioSurveillanceProgram"
                                      value={
                                        TERSampleDetails?.bioSurveillanceProgram
                                      }
                                      disabled
                                    >
                                      <option selected>-- Select --</option>
                                      {bioSurveillanceProgramsOptions &&
                                        bioSurveillanceProgramsOptions.map(
                                          (x) => {
                                            return (
                                              <option value={x.label}>
                                                {x.label}
                                              </option>
                                            );
                                          }
                                        )}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="row-mt-2">
                          <div className="row">
                            <div className="col-lg-3 mt-2">
                              <label
                                className="form-check-label"
                                htmlFor="countryofBirth"
                              >
                                Country of Origin
                                <span className="star-red">*</span>
                              </label>
                            </div>
                            <div className="col-lg-3 mt-2">
                              <select
                                id="countryofBirth"
                                name="countryofBirth"
                                disabled
                                value={TERSampleDetails?.countryofBirth}
                                className="form-select"
                                required
                              >
                                <option value="" disabled hidden>
                                  Choose a Country
                                </option>
                                {countryOfOriginOptions &&
                                  countryOfOriginOptions.map((x) => {
                                    return (
                                      <option value={x.name}>{x.name}</option>
                                    );
                                  })}
                              </select>
                            </div>

                            <div className="col-lg-3">
                              <label htmlFor="sampledBy">
                                Country of Destination
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <Select
                                className="form-selected"
                                options={countryOptions}
                                value={countryOptions.find(
                                  (option) =>
                                    option.value ===
                                    TERSampleDetails?.exportercountryOfDestination
                                )}
                                isDisabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-lg-3">
                            <label className="form-check-label">
                              Sampling From Date{" "}
                              <span className="star-red">*</span>
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="datetime-local"
                              className={`form-control ${
                                TERSampleDetails?.samplingToDate &&
                                moment(
                                  TERSampleDetails?.samplingToDate
                                ).isBefore(
                                  moment(TERSampleDetails?.samplingFromDate)
                                )
                                  ? "border-danger"
                                  : ""
                              }`}
                              name="samplingFromDate"
                              disabled
                              value={
                                TERSampleDetails?.samplingFromDate
                                  ? moment(
                                      TERSampleDetails.samplingFromDate
                                    ).format("YYYY-MM-DDTHH:mm")
                                  : ""
                              }
                            />
                          </div>
                          <div className="col-lg-3">
                            <label className="form-check-label">
                              Sampling To Date{" "}
                              <span className="star-red">*</span>
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="datetime-local"
                              className={`form-control ${
                                TERSampleDetails?.samplingFromDate &&
                                moment(
                                  TERSampleDetails?.samplingToDate
                                ).isBefore(
                                  moment(TERSampleDetails?.samplingFromDate)
                                )
                                  ? "border-danger"
                                  : ""
                              }`}
                              name="samplingToDate"
                              disabled
                              value={
                                TERSampleDetails?.samplingToDate
                                  ? moment(
                                      TERSampleDetails.samplingToDate
                                    ).format("YYYY-MM-DDTHH:mm")
                                  : ""
                              }
                            />
                          </div>
                        </div>

                        <div className="row-mt-2">
                          <div className="row">
                            <div className="col-lg-3">
                              <label htmlFor="sampledBy">
                                Sampled By <span className="star-red">*</span>
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <input
                                type="text"
                                id="sampledBy"
                                name="sampledBy"
                                value={TERSampleDetails?.sampledBy}
                                disabled
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="countryofBirth"
                              >
                                Date to be Exported
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <input
                                type="date"
                                id="dateExportedDate"
                                name="dateExportedDate"
                                disabled
                                value={
                                  TERSampleDetails?.dateExportedDate
                                    ? moment(
                                        TERSampleDetails?.dateExportedDate
                                      ).format("YYYY-MM-DD")
                                    : ""
                                }
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2"></div>

                        <div className="col-lg-3">
                          <label className="form-check-label">
                            <a
                              href="#"
                              className="font-weight-500"
                              onClick={handleToggleFarmLocationDetails}
                            >
                              Farm/Location Details{" "}
                              {showFarmLocationDetails ? "[-]" : "[+]"}
                            </a>
                          </label>
                        </div>
                        {showFarmLocationDetails && (
                          <>
                            {TERSampleDetails?.farmCode && (
                              <div className="row mb-2">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Farm Code
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="col-lg-12 mt-2">
                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          name="farmCode"
                                          value={TERSampleDetails?.farmCode}
                                          disabled
                                        >
                                          <option selected>-- Select --</option>
                                          {premisesCodeOptions.map((option) => (
                                            <option
                                              key={option.value}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </option>
                                          ))}
                                          <option
                                            key="specialFarmCode"
                                            value="specialfarmCode"
                                          >
                                            Special Farm Code
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {TERSampleDetails?.farmCode ===
                              "specialfarmCode" && (
                              <div className="row mb-3">
                                <div className="col-lg-6">
                                  <div className="row align-items-center">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor="specialFarmCode"
                                      >
                                        Special Farm Code
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <input
                                        id="specialFarmCode"
                                        type="text"
                                        className="form-control"
                                        disabled
                                        name="specialFarmCode"
                                        value={
                                          TERSampleDetails?.specialFarmCode ||
                                          ""
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="row align-items-center">
                              <div className="col-lg-3">
                                <label htmlFor="latitude" className="mb-0">
                                  Latitude (Decimal Degrees)
                                </label>
                              </div>

                              <div className="col-lg-3">
                                <input
                                  type="text"
                                  id="latitude"
                                  name="latitude"
                                  value={TERSampleDetails?.latitude}
                                  disabled
                                  className="form-control"
                                  maxLength={100}
                                />
                              </div>

                              <div className="col-lg-3">
                                <label htmlFor="longitude" className="mb-0">
                                  Longitude (Decimal Degrees)
                                </label>
                              </div>

                              <div className="col-lg-3">
                                <input
                                  type="text"
                                  id="longitude"
                                  name="longitude"
                                  value={TERSampleDetails?.longitude}
                                  disabled
                                  className="form-control"
                                  maxLength={100}
                                />
                              </div>
                            </div>
                            <div className="row mt-2 align-items-center">
                              <div className="col-lg-3">
                                <label
                                  className="form-check-label"
                                  htmlFor="farmLocationName"
                                >
                                  Location Name
                                </label>
                              </div>
                              <div className="col-lg-3">
                                <input
                                  type="text"
                                  disabled
                                  className="form-control"
                                  name="farmLocationName"
                                  value={TERSampleDetails?.farmLocationName}
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-3">
                                <label className="form-check-label">
                                  Farm/Location Address
                                </label>
                              </div>
                              <div className="col-lg-3">
                                <div className="form-checked">
                                  <label
                                    htmlFor="local"
                                    className="form-check-label"
                                  >
                                    <input
                                      type="radio"
                                      id="local"
                                      name="addressType"
                                      value="Local"
                                      className="form-check-input"
                                      checked={
                                        TERSampleDetails?.addressType ===
                                        "Local"
                                      }
                                      disabled
                                    />
                                    Local
                                  </label>
                                  <label
                                    htmlFor="foreign"
                                    className="form-check-label"
                                  >
                                    <input
                                      type="radio"
                                      id="foreign"
                                      name="addressType"
                                      className="form-check-input"
                                      value="Foreign"
                                      checked={
                                        TERSampleDetails?.addressType ===
                                        "Foreign"
                                      }
                                      disabled
                                    />
                                    Foreign
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="address">
                              <div className="row mt-2">
                                <div className="col-lg-12">
                                  <div>
                                    <label htmlFor="postalCode">
                                      Postal Code
                                    </label>
                                    <input
                                      type="text"
                                      id="postalCode"
                                      name="postalCode"
                                      className="form-control"
                                      value={TERSampleDetails?.postalCode}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div>
                                  <label htmlFor="streetName">
                                    Street/Road Name
                                  </label>
                                  <input
                                    type="text"
                                    id="streetName"
                                    name="roadName"
                                    value={TERSampleDetails?.roadName}
                                    disabled
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>
                              </div>

                              <div className="row mt-4">
                                <div className="col-lg-4">
                                  <label htmlFor="blockHouseNo">
                                    Block/House No
                                  </label>
                                  <input
                                    type="text"
                                    id="blockHouseNo"
                                    name="blockHouseNo"
                                    disabled
                                    value={TERSampleDetails?.houseNo}
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>
                                <div className="block">
                                  <label htmlFor="level">Level</label>
                                  <input
                                    type="text"
                                    id="level"
                                    name="level"
                                    value={TERSampleDetails?.level}
                                    disabled
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>
                                <div className="col-lg-4">
                                  <label htmlFor="unitNo">Unit No</label>
                                  <input
                                    type="text"
                                    id="unitNo"
                                    name="unitNo"
                                    value={TERSampleDetails?.unitNo}
                                    disabled
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div>
                                  <label htmlFor="buildingName">
                                    Building Name
                                  </label>
                                  <input
                                    type="text"
                                    id="buildingName"
                                    name="buildingName"
                                    value={TERSampleDetails?.buildingName}
                                    disabled
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>
                              </div>

                              <div className="row mt-4">
                                <div className="col-lg-6">
                                  <label htmlFor="cityName">City Name</label>
                                  <input
                                    type="text"
                                    id="cityName"
                                    name="cityName"
                                    disabled
                                    value={TERSampleDetails?.cityName}
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>

                                <div className="col-lg-6">
                                  <label htmlFor="State">State/Province</label>
                                  <input
                                    type="text"
                                    id="state"
                                    name="state"
                                    value={TERSampleDetails?.state}
                                    disabled
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div>
                                  <label htmlFor="country">Country</label>
                                  <input
                                    type="text"
                                    id="country"
                                    name="country"
                                    value={TERSampleDetails?.country}
                                    disabled
                                    className="form-control"
                                    maxLength={255}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            <a
                              href="#"
                              className="font-weight-500"
                              onClick={handleToggleForm}
                            >
                              History & Remarks: {showForm ? "[-]" : "[+]"}
                            </a>
                          </label>
                        </div>
                      </div>
                      {showForm && (
                        <div className="row">
                          <div className="col-lg-3">
                            <label htmlFor="historyAndRemarks"></label>
                          </div>
                          <div className="col-lg-9">
                            <textarea
                              id="history_Remarks"
                              disabled
                              name="history_Remarks"
                              value={TERSampleDetails?.history_Remarks}
                              className="form-control"
                              maxLength={155}
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-lg-3">
                        <label className="form-check-label">
                          <a
                            href=""
                            className="font-weight-500"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleQuarantineInfo();
                            }}
                          >
                            Quarantine Information{" "}
                            {showQuarantineInfo ? "[-]" : "[+]"}
                          </a>
                        </label>

                        {showQuarantineInfo && (
                          <div>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    name="inQuarantine"
                                    disabled
                                    checked={TERSampleDetails?.inQuarantine}
                                    className="form-check-input mt10"
                                  />
                                  <label className="form-check-label">
                                    In Quarantine
                                  </label>
                                </div>
                              </div>
                            </div>

                            {TERSampleDetails?.inQuarantine && (
                              <div className="col-lg-12">
                                <div className="col-lg-9">
                                  <label className="form-check-label">
                                    Import Licence No
                                  </label>
                                </div>
                                <input
                                  type="text"
                                  id="importLicenseNo"
                                  name="importLicenseNo"
                                  disabled
                                  value={TERSampleDetails?.importLicenseNo}
                                  className="form-control"
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="personal-info">
                      <div className="info-heading">
                        <h2 className="pb-0">Clinical History</h2>
                      </div>
                      <div className="info-content">
                        <div className="row">
                          <div className="col-lg-3">
                            <label className="form-check-label">
                              Health Status<span className="star-red">*</span>
                            </label>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-checked">
                              <label
                                htmlFor="Healthy"
                                className="form-check-label"
                              >
                                <input
                                  type="radio"
                                  id="Healthy"
                                  name="healthy"
                                  value="1"
                                  className="form-check-input"
                                  checked={TERSampleDetails?.healthy === 1}
                                  required
                                  disabled
                                />
                                Healthy
                              </label>
                              <label
                                htmlFor="Diseased"
                                className="form-check-label"
                              >
                                <input
                                  type="radio"
                                  id="Diseased"
                                  name="healthy"
                                  value="2"
                                  className="form-check-input"
                                  checked={TERSampleDetails?.healthy === 2}
                                  disabled
                                />
                                Diseased
                              </label>
                            </div>
                          </div>
                          {TERSampleDetails?.healthy === 2 && (
                            <div className="row">
                              <div className="col-lg-2">
                                <label className="form-check-label" htmlFor="">
                                  Disease Started on
                                </label>
                              </div>
                              <div className="col-lg-4">
                                <div
                                  className="input-group date"
                                  id="datepicker"
                                >
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="date"
                                    placeholder="DD/MM/YYYY"
                                    name="diseaseStartedon"
                                    value={
                                      TERSampleDetails?.diseaseStartedon ?? ""
                                    }
                                    disabled
                                    max={maxdate}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 align-disease">
                                <b>OR</b>
                                <input
                                  type="number"
                                  name="ago"
                                  value={TERSampleDetails?.ago}
                                  disabled
                                  className="form-control ms-2"
                                  placeholder=""
                                />
                                <select
                                  value={TERSampleDetails?.yearsmonth}
                                  name="yearsmonth"
                                  disabled
                                  className="form-select ms-2"
                                  aria-label="Default select example"
                                >
                                  <option selected />

                                  <option value={1}>Days</option>
                                  <option value={2}>Weeks</option>
                                  <option value={3}>Months</option>
                                  <option value={4}>Years</option>
                                </select>
                                <p className="ms-2">ago</p>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-lg-2">
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault1"
                            >
                              <a href="#" onClick={handleDiseaseSignClick}>
                                Disease Sign: [
                                {showAdditionalContent ? "-" : "+"}]
                              </a>
                            </label>
                          </div>
                        </div>
                        <div className="row">
                          {showAdditionalContent && (
                            <div className="col-lg-12">
                              <div className="row">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Disease Pattern
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <select
                                    className="form-select"
                                    name="pattern"
                                    disabled
                                    value={TERSampleDetails?.pattern}
                                    aria-label="Default select example"
                                  >
                                    <option selected />

                                    <option value={1}>
                                      Increasing Mortality
                                    </option>
                                    <option value={2}>
                                      {" "}
                                      Low Grade Mortality
                                    </option>
                                    <option value={3}>
                                      Only Clinical Signs, No Mortality
                                    </option>
                                    <option value={4}>Sudden Deaths</option>
                                  </select>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Total No. on Premises
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder=""
                                    name="totalNoonPremises"
                                    value={TERSampleDetails?.totalNoonPremises}
                                    disabled
                                  />
                                </div>
                                <div className="col-lg-1"></div>
                                <div className="col-lg-1">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    No. Dead Daily
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder=""
                                    name="noDeadDaily"
                                    value={TERSampleDetails?.noDeadDaily}
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    No. or % Diseased
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder=""
                                    name="noDiseased"
                                    value={TERSampleDetails?.noDiseased}
                                    disabled
                                  />
                                </div>
                                <div className="col-lg-1">
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    name="noOrDiseasedOptions"
                                    value={
                                      TERSampleDetails?.noOrDiseasedOptions
                                    }
                                    disabled
                                  >
                                    <option selected />

                                    <option value={1}>Nos.</option>
                                    <option value={2}>%</option>
                                  </select>
                                </div>
                                <div className="col-lg-1">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Total No. Dead
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    name="totalNoDead"
                                    className="form-control"
                                    placeholder=""
                                    value={TERSampleDetails?.totalNoDead}
                                    maxLength={20}
                                    disabled
                                  />
                                </div>
                                <div className="col-lg-1"></div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Total No. of Units
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    name="totalNoofunits"
                                    value={TERSampleDetails?.totalNoofunits}
                                    maxLength={20}
                                    disabled
                                    className="form-control"
                                    placeholder=""
                                  />
                                </div>
                                <div className="col-lg-1">
                                  <select
                                    className="form-select"
                                    name="noOfUnitsOptions"
                                    value={TERSampleDetails?.noOfUnitsOptions}
                                    disabled
                                    aria-label="Default select example"
                                  >
                                    <option selected />

                                    <option value={1}>nets</option>
                                    <option value={2}>ponds</option>
                                    <option value={3}>tanks</option>
                                  </select>
                                </div>
                                <div className="col-lg-1">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Unit Size
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    name="unitSize"
                                    value={TERSampleDetails?.unitSize}
                                    disabled
                                    className="form-control"
                                    placeholder=""
                                  />
                                </div>

                                <div className="col-lg-1">
                                  <select
                                    className="form-select"
                                    name="unitsizeoptions"
                                    aria-label="Default select example"
                                    value={TERSampleDetails?.unitsizeoptions}
                                    disabled
                                  >
                                    <option selected />

                                    <option value={1}>cm</option>
                                    <option value={2}>feet</option>
                                    <option value={3}>m</option>
                                  </select>
                                </div>
                              </div>
                              <div>
                                <div className="row">
                                  <div className="col-lg-3">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      Farm Area
                                    </label>
                                  </div>
                                  <div className="col-lg-2">
                                    <input
                                      type="number"
                                      name="farmArea"
                                      className="form-control"
                                      value={TERSampleDetails?.farmArea}
                                      disabled
                                    />
                                  </div>
                                  <div className="col-lg-1">
                                    <select
                                      className="form-select"
                                      name="farmAreaOptions"
                                      value={TERSampleDetails?.farmAreaOptions}
                                      disabled
                                      aria-label="Default select example"
                                    >
                                      <option selected />

                                      <option value={1}>ha</option>
                                      <option value={2}>m2</option>
                                    </select>
                                  </div>
                                  <div className="col-lg-1">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      No.Affected
                                    </label>
                                  </div>
                                  <div className="col-lg-2">
                                    <input
                                      type="number"
                                      name="noAfffected"
                                      value={TERSampleDetails?.noAfffected}
                                      disabled
                                      className="form-control"
                                      placeholder=""
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Age Affected
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    name="ageAffected"
                                    disabled
                                    className="form-control"
                                    value={TERSampleDetails?.ageAffected}
                                  />
                                </div>
                                <div className="col-lg-1">
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    name="ageAffectedOptions"
                                    value={TERSampleDetails?.ageAffectedOptions}
                                    disabled
                                  >
                                    <option selected />

                                    <option value={1}>days</option>
                                    <option value={2}>weeks</option>
                                    <option value={3}>months</option>
                                    <option value={4}>years</option>
                                  </select>
                                </div>
                                <div className="col-lg-1">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Size Affected
                                  </label>
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    name="sizeAffected"
                                    value={TERSampleDetails?.sizeAffected}
                                    maxLength={20}
                                    disabled
                                    className="form-control"
                                    placeholder=""
                                  />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Other Species/Breed Affected
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    name="otherSpeciesAffected"
                                    maxLength={100}
                                    className="form-control"
                                    value={
                                      TERSampleDetails?.otherSpeciesAffected
                                    }
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Clinical Signs &amp; Remarks
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <textarea
                                    className="form-control"
                                    id="floatingTextarea"
                                    name="clinicalSigns"
                                    maxLength={500}
                                    value={TERSampleDetails?.clinicalSigns}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <label
                              className="form-check-label"
                              htmlFor="clinicalManagement"
                            >
                              <a
                                href=""
                                className="font-weight-500"
                                onClick={(e) => {
                                  e.preventDefault();
                                  toggleClinicalManagement();
                                }}
                              >
                                Clinical Management (Signs, Treatment &
                                Remarks):{" "}
                                {isClinicalManagementExpanded ? "[-]" : "[+]"}
                              </a>
                            </label>
                          </div>
                          {isClinicalManagementExpanded && (
                            <div className="row">
                              <div className="col-lg-12">
                                <textarea
                                  id="clinicalManagement"
                                  disabled
                                  name="clinicalManagement"
                                  value={TERSampleDetails?.clinicalManagement}
                                  className="form-control"
                                ></textarea>
                              </div>
                            </div>
                          )}
                          <div className="row">
                            <div className="col-lg-12">
                              <label
                                className="form-check-label"
                                htmlFor="vaccinationHistory"
                              >
                                <a
                                  href=""
                                  className="font-weight-500"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    toggleVaccinationHistory();
                                  }}
                                >
                                  Vaccination History{" "}
                                  {isVaccinationHistoryExpanded ? "[-]" : "[+]"}
                                </a>
                              </label>
                            </div>
                            {isVaccinationHistoryExpanded && (
                              <div className="col-lg-12">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Clinical/Vaccination History
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <textarea
                                  id="vaccinationHistory"
                                  name="vaccinationHistory"
                                  value={TERSampleDetails?.vaccinationHistory}
                                  required
                                  disabled
                                  className="form-control"
                                ></textarea>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="info-heading mt-2">
            <h3 className="info-h3">Samples And Tests</h3>
          </div>
          {pageLoader ? (
            <Loader />
          ) : (
            samplesAndTests &&
            samplesAndTests.map(
              (sample: ITERSamplesAndTests, index: number) => {
                return (
                  <div className="personal-info" key={index}>
                    <div className="clonable-block" data-toggle="cloner">
                      <div className="clonable" data-clone-number={index + 1}>
                        <div className="info-heading">
                          <h2 className="pb-0">Serial number {index + 1}</h2>
                        </div>
                        <div className="info-content">
                          <div className="table-responsive mt-2 mb-2">
                            <table className="table table-striped product_table start_table">
                              <thead>
                                <tr>
                                  <th className="w-20">
                                    Animal Type
                                    <span className="star-red">*</span>
                                  </th>
                                  <th className="w-20">
                                    Species/Breed
                                    <span className="star-red">*</span>
                                  </th>
                                  <th className="w-20">
                                    Sample Description
                                    <span className="star-red">*</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <select
                                      className={`form-select ${
                                        sample?.speciesErrMsg
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      aria-label="Default select example"
                                      value={sample.species}
                                      disabled
                                      name="species"
                                    >
                                      <option selected />
                                      {speciesOptions &&
                                        speciesOptions.map((x) => {
                                          return (
                                            <option value={x.speciesName}>
                                              {x.speciesName}
                                            </option>
                                          );
                                        })}
                                      <option value="Others">Others</option>
                                    </select>
                                    {sample.species === "Others" && (
                                      <input
                                        type="text"
                                        className="form-control mt-2"
                                        value={sample.otherSpecies}
                                        name="otherSpecies"
                                        disabled
                                      />
                                    )}
                                  </td>
                                  <td>
                                    {" "}
                                    <select
                                      className={`form-select ${
                                        sample?.breedErrMsg
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      aria-label="Default select example"
                                      value={sample.breed}
                                      name="breed"
                                      disabled
                                    >
                                      <option selected />
                                      {breedOptions &&
                                        breedOptions.map((x) => {
                                          return (
                                            <option value={x.breedName}>
                                              {x.breedName}
                                            </option>
                                          );
                                        })}
                                      <option value="Others">Others</option>
                                    </select>
                                    {sample.breed === "Others" && (
                                      <input
                                        type="text"
                                        className="form-control mt-2"
                                        name="otherBreed"
                                        value={sample.otherBreed}
                                        disabled
                                      />
                                    )}
                                  </td>
                                  <td>
                                    <select
                                      className={`form-select ${
                                        sample?.specimenDescriptionErrMsg
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      aria-label="Default select example"
                                      value={sample.specimenDescription}
                                      name="specimenDescription"
                                      disabled
                                    >
                                      <option selected />
                                      {specimenOptions &&
                                        specimenOptions.map((x) => {
                                          return (
                                            <option
                                              value={x.labSpecimenDescription}
                                            >
                                              {x.labSpecimenDescription}
                                            </option>
                                          );
                                        })}
                                      <option value="Others">Others</option>
                                    </select>
                                    {sample.specimenDescription ===
                                      "Others" && (
                                      <input
                                        type="text"
                                        className="form-control mt-2"
                                        name="otherSpecimenDescription"
                                        value={sample.otherSpecimenDescription}
                                        disabled
                                      />
                                    )}
                                  </td>
                                </tr>

                                <tr>
                                  <td className="fnt-wg tr-ignore">
                                    <div className="mb-3 ">
                                      <div className="mb-2">
                                        <label
                                          htmlFor="staticEmail"
                                          className="col-form-label"
                                        >
                                          Sample Marking{" "}
                                          <span className="star-red">*</span>
                                        </label>
                                        <div className="input-group date">
                                          <input
                                            type="text"
                                            name="sampleMarking"
                                            value={sample?.sampleMarking}
                                            className={`form-control ${
                                              !sample?.sampleMarking
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="fnt-wg tr-ignore">
                                    <div className="mb-3 ">
                                      <div className="mb-2">
                                        <label
                                          htmlFor="staticEmail"
                                          className="col-form-label"
                                        >
                                          Number of Samples
                                          <span className="star-red">*</span>
                                        </label>
                                        <div className="input-group date">
                                          <input
                                            type="number"
                                            min="1"
                                            name="noOfSamples"
                                            className="form-control"
                                            value={sample?.noOfSamples ?? 1}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="fnt-wg tr-ignore">
                                    <div className="mb-3 ">
                                      <div className="mb-2">
                                        <label
                                          htmlFor="staticEmail"
                                          className="col-form-label"
                                        >
                                          Test Information
                                          <span className="star-red">*</span>
                                        </label>
                                        <div className="input-group date">
                                          <button
                                            className="btn btn-outline-success w-100 "
                                            type="button"
                                            disabled
                                            data-bs-toggle="modal"
                                            data-bs-target="#staticBackdrop1"
                                          >
                                            Search Test
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>

                                {sample.labTERTestDetails &&
                                  sample.labTERTestDetails
                                    .filter(
                                      (test) => test.testDescription !== ""
                                    )
                                    .map((test, testIndex) => (
                                      <tr
                                        key={`test-row-${index}-${testIndex}`}
                                      >
                                        <td className="br-1" colSpan={2}>
                                          <div className="mb-3">
                                            <div className="mb-2">
                                              <div className="test-detail">
                                                <div
                                                  id={`testDescription-${index}-${test.labTestID}`}
                                                  className="test-description"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      test.testDescription,
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                        <td className="fnt-wg tr-ignore">
                                          <div className="mb-3">
                                            <div className="mb-2">
                                              <label
                                                htmlFor={`repeatCount-${index}-${testIndex}`}
                                                className="col-form-label float-start"
                                              >
                                                Number of Tests
                                                <span className="star-red">
                                                  *
                                                </span>
                                              </label>
                                              <div className="input-group date">
                                                <input
                                                  type="number"
                                                  id={`repeatCount-${index}-${testIndex}`}
                                                  min="1"
                                                  className="form-control"
                                                  value={
                                                    test.nooftestsrequired ?? 1
                                                  }
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}

                                {sample.labTERTestDetails && (
                                  <>
                                    {sample.labTERTestDetails.some(
                                      (test) =>
                                        test.testMethodSOPDescription
                                          ?.trim()
                                          .toLowerCase() === "post-mortem"
                                    ) && (
                                      <tr>
                                        <td colSpan={5}>
                                          <div className="col-lg-12">
                                            <label
                                              className="form-check-label"
                                              htmlFor="flexRadioDefault1"
                                            >
                                              <a
                                                href=""
                                                className="font-weight-500"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setShowPostMortem(
                                                    !showPostMortem
                                                  );
                                                }}
                                              >
                                                For Post Mortem:{" "}
                                                {showPostMortem ? "[-]" : "[+]"}
                                              </a>
                                            </label>

                                            {showPostMortem && (
                                              <>
                                                <div className="row">
                                                  <div className="col-lg-4">
                                                    <label
                                                      htmlFor="supportDocuments"
                                                      className="form-check-label"
                                                      title="Documents allowed: pdf, docx, doc, jpg, jpeg, png, xlsx, xls."
                                                    >
                                                      Post-Mortem Consent Form
                                                      <span className="star-red">
                                                        *
                                                      </span>
                                                    </label>

                                                    <div className="col-lg-12">
                                                      {sample?.postMortemConsentFormName ? (
                                                        <div className="file-view">
                                                          {
                                                            sample?.postMortemConsentFormName
                                                          }
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="col-lg-4">
                                                    <label className="form-check-label">
                                                      Save Remains for
                                                      Burial/Cremation
                                                      <span className="star-red">
                                                        *
                                                      </span>
                                                    </label>
                                                    <div className="form-checked">
                                                      <select
                                                        id="saveRemains"
                                                        name="saveRemains"
                                                        className="form-select"
                                                        value={
                                                          sample?.saveRemains ||
                                                          ""
                                                        }
                                                        disabled
                                                      >
                                                        <option value="">
                                                          Select an option
                                                        </option>
                                                        <option value="Yes">
                                                          Yes
                                                        </option>
                                                        <option value="No">
                                                          No
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div className="col-lg-4">
                                                    <label className="form-check-label">
                                                      Animal Status
                                                    </label>
                                                    <div className="form-checked">
                                                      <label
                                                        htmlFor="alive"
                                                        className="form-check-label"
                                                      >
                                                        <input
                                                          type="radio"
                                                          name="animalStatus"
                                                          value="1"
                                                          className="form-check-input"
                                                          checked={
                                                            sample?.animalStatus ===
                                                            1
                                                          }
                                                          disabled
                                                        />
                                                        Alive
                                                      </label>
                                                      <label
                                                        htmlFor="dead"
                                                        className="form-check-label"
                                                      >
                                                        <input
                                                          type="radio"
                                                          name="animalStatus"
                                                          value="2"
                                                          className="form-check-input"
                                                          checked={
                                                            sample?.animalStatus ===
                                                            2
                                                          }
                                                          disabled
                                                        />
                                                        Dead
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div className="col-lg-4">
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor="Remarks"
                                                    >
                                                      Remarks
                                                    </label>
                                                    <textarea
                                                      className="form-control"
                                                      name="remarks"
                                                      value={sample?.remarks}
                                                      maxLength={500}
                                                      disabled
                                                    />
                                                  </div>
                                                </div>
                                                <div className="form-check col-lg-12">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input mt10"
                                                    id="euthanised"
                                                    checked={sample?.euthanised}
                                                    disabled
                                                  />
                                                  <label
                                                    className="form-check-label"
                                                    htmlFor="euthanised"
                                                  >
                                                    Euthanised
                                                  </label>
                                                </div>

                                                {sample?.euthanised && (
                                                  <>
                                                    <div className="col-lg-3">
                                                      <label
                                                        htmlFor="euthanisedDate"
                                                        className="form-check-label"
                                                      >
                                                        Euthanised Date
                                                      </label>
                                                      <input
                                                        type="date"
                                                        id="euthanisedDate"
                                                        name="euthanisedDate"
                                                        value={
                                                          sample?.euthanisedDate
                                                            ? moment(
                                                                sample?.euthanisedDate
                                                              ).format(
                                                                "YYYY-MM-DD"
                                                              )
                                                            : ""
                                                        }
                                                        disabled
                                                        className="form-control"
                                                      />
                                                    </div>

                                                    <div className="col-lg-3">
                                                      <label
                                                        htmlFor="methodofEuthanised"
                                                        className="col-form-label"
                                                      >
                                                        Method of Euthanasia
                                                      </label>
                                                      <input
                                                        type="text"
                                                        id="methodofEuthanised"
                                                        name="methodofEuthanised"
                                                        value={
                                                          sample?.methodofEuthanised ||
                                                          ""
                                                        }
                                                        maxLength={100}
                                                        className="form-control"
                                                        disabled
                                                      />
                                                    </div>
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </>
                                )}
                                <div className="col-lg-12">
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    <a
                                      href=""
                                      className="font-weight-500"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setShowGroupAnimals(!showGroupAnimals);
                                      }}
                                    >
                                      For Group Animals:{" "}
                                      {showGroupAnimals ? "[-]" : "[+]"}
                                    </a>
                                  </label>
                                </div>
                                {showGroupAnimals && (
                                  <>
                                    <tr>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              No. on Premises
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={sample.noOnPremises}
                                                name="noOnPremises"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              No. in Group/Pen
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={sample.noInGroup}
                                                name="noInGroup"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              No. Sick
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={sample.noSick}
                                                name="noSick"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              No. Dead
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={sample.noDead}
                                                name="noDead"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              No. at Risk
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={sample.noAtRisk}
                                                name="noAtRisk"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              Herd/Group ID
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={sample.groupID}
                                                name="groupID"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              House/Pen No
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={sample.penNo}
                                                name="penNo"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                )}
                                <div className="col-lg-12">
                                  <label className="form-check-label">
                                    <a
                                      href="#"
                                      className="font-weight-500"
                                      onClick={handleToggleFarmDetails}
                                    >
                                      For Individual Animal{" "}
                                      {showFarmDetails ? "[-]" : "[+]"}
                                    </a>
                                  </label>
                                </div>
                                {showFarmDetails && (
                                  <>
                                    <tr>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              Owner
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={sample.owner}
                                                name="owner"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              Name of Animal
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={sample.nameofAnimal}
                                                name="nameofAnimal"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              ID/Microchip No.
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={sample.microchipNo}
                                                name="microchipNo"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              Date of Birth
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="date"
                                                className="form-control"
                                                value={
                                                  sample?.dateofBirth ?? ""
                                                }
                                                name="dateofBirth"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="Sterilized"
                                              className="col-form-label"
                                            >
                                              Sterilized
                                            </label>

                                            <select
                                              className="form-select"
                                              name="sterilized"
                                              disabled
                                              value={sample?.sterilized}
                                              aria-label="Default select example"
                                            >
                                              <option selected>
                                                {" "}
                                                -- Select --
                                              </option>

                                              <option value={1}>Yes</option>
                                              <option value={2}> No</option>
                                              <option value={3}>Unknown</option>
                                            </select>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="countryOfResidence"
                                              className="col-form-label"
                                            >
                                              Country of Residence
                                            </label>

                                            <Select
                                              options={countryOptions}
                                              value={countryOptions.find(
                                                (option) =>
                                                  option.value ===
                                                  sample.countryofResidence
                                              )}
                                              isDisabled
                                            />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="gender"
                                              className="col-form-label"
                                            >
                                              sex
                                            </label>
                                            <div className="input-group">
                                              <label
                                                className="form-check-label me-2"
                                                htmlFor="male"
                                              >
                                                <input
                                                  type="radio"
                                                  id={`male-${index}`}
                                                  name={`gender-${index}`}
                                                  value="Male"
                                                  disabled
                                                  checked={
                                                    sample?.gender === "Male"
                                                  }
                                                  className="form-check-input"
                                                />
                                                Male
                                              </label>

                                              <label
                                                className="form-check-label me-2"
                                                htmlFor="female"
                                              >
                                                <input
                                                  type="radio"
                                                  id={`female-${index}`}
                                                  name={`gender-${index}`}
                                                  value="Female"
                                                  disabled
                                                  checked={
                                                    sample?.gender === "Female"
                                                  }
                                                  className="form-check-input"
                                                />
                                                Female
                                              </label>

                                              <label
                                                className="form-check-label"
                                                htmlFor="unknown"
                                              >
                                                <input
                                                  type="radio"
                                                  id={`unknown-${index}`}
                                                  name={`gender-${index}`}
                                                  value="unknown"
                                                  disabled
                                                  checked={
                                                    sample?.gender === "unknown"
                                                  }
                                                  className="form-check-input"
                                                />
                                                Unknown
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        colSpan={3}
                                        className="fnt-wg tr-ignore"
                                      >
                                        <div className="mb-3">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="age"
                                              className="col-form-label"
                                            >
                                              Age
                                            </label>
                                            <div className="input-group">
                                              <div className="row">
                                                <div className="col-lg-3">
                                                  <label className="form-label">
                                                    Years
                                                  </label>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    name="years"
                                                    value={sample?.years}
                                                    disabled
                                                    placeholder="yrs"
                                                  />
                                                </div>
                                                <div className="col-lg-3">
                                                  <label className="form-label">
                                                    Months
                                                  </label>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    name="months"
                                                    value={sample?.months}
                                                    disabled
                                                    placeholder="mths"
                                                  />
                                                </div>
                                                <div className="col-lg-3">
                                                  <label className="form-label">
                                                    Weeks
                                                  </label>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    name="weeks"
                                                    value={sample?.weeks}
                                                    disabled
                                                    placeholder="weeks"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <hr></hr>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            )
          )}
        </div>
        <div className="info-heading mt-2">
          <h3 className="info-h3">My Preference</h3>
        </div>
        {pageLoader ? (
          <Loader />
        ) : (
          Preference &&
          Preference.map((x: IlabTERPreference, ind: number) => {
            return (
              <div className="personal-info" key={ind}>
                <div className="clonable-block">
                  <div className="clonable">
                    <div className="info-content">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="SpecialInstructions"
                              >
                                For Bacterial Culture Only
                              </label>
                            </div>
                            <div className="col-lg-7 d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                disabled
                                name="antimicrobialSusceptibilityTestRequired"
                                checked={
                                  x?.antimicrobialSusceptibilityTestRequired
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="antimicrobialSusceptibilityTestRequired"
                              >
                                Antimicrobial Susceptibility Test Required
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="specialInstructions"
                              >
                                Special Instructions/ Additional Information
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <textarea
                                className="form-control"
                                name="specialInstructions"
                                value={x.specialInstructions}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row mt-2 mt-lg-0">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="otherRemarks"
                              >
                                Other Remarks
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <textarea
                                className="form-control"
                                name="resultReportingInstr"
                                value={x.remarks}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="supportDocuments"
                              >
                                Support Documents
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <div className="file-view mt-2">
                                {x?.supportDocumentName
                                  ? x.supportDocumentName
                                  : "No file attached"}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 mt-3">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="modeOfReceiving"
                              >
                                Mode of receiving report
                                <span className="star-red">*</span>
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <select
                                name="modeOfReceiving"
                                disabled
                                value={x?.modeOfReceiving}
                                className="form-select"
                                aria-label="Mode of receiving report"
                              >
                                <option value="" disabled>
                                  Select an option
                                </option>
                                <option value={2}>Email</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {x?.modeOfReceiving === 1 && (
                          <div className="row mt-2">
                            <div className="col-lg-6">
                              <label className="form-check-label fw-bold mb-2">
                                Please select the address for mailing:
                              </label>
                              <select
                                name="mailingAddress"
                                className="form-select mb-3"
                                value={x?.mailingAddress}
                                disabled
                              >
                                <option value="" disabled hidden>
                                  Please Select address
                                </option>
                                <option value={1}>
                                  Same as mailing address
                                </option>
                                <option value={2}>
                                  Same as billing address
                                </option>
                                <option value={3}>
                                  Others (please specify)
                                </option>
                              </select>

                              {x?.mailingAddress === 3 && (
                                <div className="col-lg-12">
                                  <textarea
                                    className="form-control mt-2"
                                    placeholder="Enter address"
                                    name="customAddress"
                                    disabled
                                    value={x?.customAddress}
                                  />
                                </div>
                              )}

                              <div className="alert alert-warning mt-3">
                                Please note that NParks is not liable for lost
                                mail, and any additional copies of laboratory
                                reports are subject to additional charges.
                              </div>

                              <div className="form-check mt-3">
                                <input
                                  type="checkbox"
                                  className="form-check-input mt-2"
                                  id="acknowledgeCheckbox"
                                  name="acknowledge"
                                  disabled
                                  checked={x?.acknowledge || false}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="acknowledgeCheckbox"
                                >
                                  I acknowledge the above information
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}

        <div className="text-end mt-3 mb-3">
          <button
            className="btn btn-d btn-secondary px-4"
            onClick={handlePreviousClick}
          >
            Previous
          </button>

          <button
            className="btn btn-primary px-4"
            onClick={handleNextClick}
            type="button"
          >
            Next
          </button>
        </div>
      </Container>

      <Footer />
    </>
  );
}

export default CAVSTERReview;
